import React from 'react';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Skeleton from '@material-ui/lab/Skeleton';
import {Skeletize} from '../../../../components';
import styled from 'styled-components';
import {conditionalStyles} from '../../../../utils/ThemeUtils';

const Root = styled.div`
    display: flex;
    align-items: center;
    margin-top: 20px;
    & > * + * {
        ${p =>
            conditionalStyles(p.theme.muiTheme.direction === 'ltr')(
                'margin-left: 40px',
                'margin-right: 40px'
            )};
    }
`;

const PostsPerPageSkeleton = styled(Skeleton)`
    width: 30px;
    height: 30px !important;
    border-radius: 4px;
`;

const PageTotalSkeleton = styled(Skeleton)`
    width: 100px;
    height: 30px !important;
    border-radius: 4px;
`;

const PageNavigateSkeleton = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 0;
`;

const BrowsePaginationSkeleton = () => (
    <Root>
        <PostsPerPageSkeleton variant="rect" />
        <PageTotalSkeleton variant="rect" />
        <PageNavigateSkeleton>
            <Skeletize>
                <bdo dir="ltr">
                    <ChevronLeftIcon />
                    <ChevronRightIcon />
                </bdo>
            </Skeletize>
        </PageNavigateSkeleton>
    </Root>
);

export default BrowsePaginationSkeleton;
